/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `WAITING` - Waiting
 *   * `APPROVED` - Approved
 *   * `REJECTED` - Rejected
 * ```
 */
export const ApprovalStateEnum = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ApprovalStateEnum = ValuesOf<typeof ApprovalStateEnum>;

export type ApprovalStateEnumRequest = ApprovalStateEnum;
export type ApprovalStateEnumResponse = ApprovalStateEnum;
